var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgReportDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "download",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3266",
    "data-name": "Group 3266"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x37__43_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3265",
    "data-name": "Group 3265"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2099",
    "data-name": "Path 2099",
    d: "M23.1,16.914l-4.507,4.508V9.844a1.094,1.094,0,0,0-2.187,0V21.422L11.9,16.915a1.094,1.094,0,0,0-1.547,1.547l6.187,6.187a1.072,1.072,0,0,0,.961.283,1.076,1.076,0,0,0,.961-.283l6.187-6.187A1.095,1.095,0,0,0,23.1,16.914ZM17.5,0A17.5,17.5,0,1,0,35,17.5,17.5,17.5,0,0,0,17.5,0Zm0,32.813A15.313,15.313,0,1,1,32.813,17.5,15.312,15.312,0,0,1,17.5,32.813Z",
    fill: "#ed193a"
  }))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportDownload);
export default __webpack_public_path__ + "static/media/report-download.eca9a335952c5a1e5d3bf5b049123423.svg";
export { ForwardRef as ReactComponent };